import React, { FunctionComponent, ReactText } from 'react'
import styles from './CenterMark.module.sass'
import clsx from 'clsx'
import { Classes } from '../../../../styles'

interface Props {
    children: ReactText,
}

const CenterMark: FunctionComponent<Props> = props => <div className={clsx(styles.mark, Classes.f13b)}>{props.children}</div>

export default CenterMark